import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { tasksAPI } from '../../lib/complianceAPI';
import { caAPI, errText } from '../../lib/complianceAutoAPI';

const today = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Australia/Sydney' });
export const LODGED = ['lodged', 'completed'];
export const needsLodgment = (t) => !!t?.compliance_period_id && !LODGED.includes(t.compliance_stage);
export const isLodgmentPrompt = (e) => e?.response?.status === 409 && /record the lodgment/i.test(errText(e));
export const taskErr = (e) => (e?.response ? errText(e) : "Couldn't reach the server – check your connection and try again");

// Asked whenever a compliance task is moved to Done without a recorded lodgment (kanban, dialog, any path).
export const LodgeToCompleteDialog = ({ task, onClose, onDone, onOpenTask }) => {
  const [lg, setLg] = useState({ lodgment_date: today(), reference: '' });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  useEffect(() => { setLg({ lodgment_date: today(), reference: '' }); setMsg(''); }, [task]);
  if (!task) return null;
  const asic = task.compliance_type === 'ASIC_REVIEW';
  const save = async () => {
    if (lg.reference.trim().length < 2) { setMsg('Enter the lodgment reference or receipt number'); return; }
    setBusy(true); setMsg('');
    try {
      await caAPI.lodge(task.compliance_period_id, { lodgment_date: lg.lodgment_date, method: 'electronic', reference: lg.reference.trim() });
      await tasksAPI.updateStatus(task.id, 'done');
      toast.success('Lodgment recorded – task marked Done');
      onDone(); onClose();
    } catch (e) { setMsg(taskErr(e)); onDone(); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="lodge-to-complete-dialog">
        <DialogHeader>
          <DialogTitle>Record the lodgment to finish</DialogTitle>
          <DialogDescription>{asic ? 'An ASIC annual review is completed by recording the review fee payment and solvency resolution.' : `${task.title} – enter the lodgment date and reference to mark it Done.`}</DialogDescription>
        </DialogHeader>
        {!asic && <div className="flex flex-wrap gap-3">
          <label className="text-xs">Lodgment date<Input type="date" className="mt-0.5 h-9 w-40" max={today()} value={lg.lodgment_date} onChange={(e) => setLg({ ...lg, lodgment_date: e.target.value })} data-testid="lodge-to-complete-date" /></label>
          <label className="text-xs flex-1">Reference / receipt<Input className="mt-0.5 h-9" value={lg.reference} onChange={(e) => setLg({ ...lg, reference: e.target.value })} data-testid="lodge-to-complete-ref" /></label>
        </div>}
        {msg && <p className="text-sm text-destructive" role="alert" data-testid="lodge-to-complete-error">{msg}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="lodge-to-complete-cancel">Cancel</Button>
          {asic ? <Button onClick={() => { onClose(); onOpenTask?.(task); }} data-testid="lodge-to-complete-open">Open task</Button>
            : <Button disabled={busy || !lg.lodgment_date} onClick={save} data-testid="lodge-to-complete-save">{busy ? 'Saving…' : 'Record lodgment and mark Done'}</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
